import React from 'react';
import BackButton from '@/components/BackButton';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <BackButton />
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto prose prose-slate dark:prose-invert">
          <h1>Terms of Service</h1>
          <p className="lead">
            Last updated: March 15, 2024
          </p>

          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using NEXUS Phish, you agree to be bound by these Terms of Service and all applicable laws and regulations.
          </p>

          <h2>2. Educational Purpose</h2>
          <p>
            NEXUS Phish is designed and intended for:
          </p>
          <ul>
            <li>Security research and testing</li>
            <li>Educational demonstrations</li>
            <li>Authorized penetration testing</li>
            <li>Security awareness training</li>
          </ul>

          <h2>3. Prohibited Uses</h2>
          <p>
            You are strictly prohibited from:
          </p>
          <ul>
            <li>Using the platform for malicious purposes</li>
            <li>Conducting unauthorized phishing attacks</li>
            <li>Collecting real user credentials without consent</li>
            <li>Violating any applicable laws or regulations</li>
            <li>Sharing access credentials or bypassing security measures</li>
          </ul>

          <h2>4. User Responsibilities</h2>
          <p>
            Users must:
          </p>
          <ul>
            <li>Obtain proper authorization before testing</li>
            <li>Use the platform responsibly and ethically</li>
            <li>Report any security vulnerabilities discovered</li>
            <li>Maintain confidentiality of access credentials</li>
          </ul>

          <h2>5. Disclaimer of Warranties</h2>
          <p>
            The platform is provided "as is" without any warranties. We are not responsible for any damages or losses resulting from your use of the platform.
          </p>

          <h2>6. Limitation of Liability</h2>
          <p>
            NEXUSCIPHERGUARD INDIA shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the platform.
          </p>

          <h2>7. Termination</h2>
          <p>
            We reserve the right to terminate or suspend access to the platform for any violation of these terms or unauthorized use.
          </p>

          <h2>8. Changes to Terms</h2>
          <p>
            We may modify these terms at any time. Continued use of the platform constitutes acceptance of the modified terms.
          </p>

          <h2>9. Contact Information</h2>
          <p>
            For questions about these Terms of Service, please contact NEXUSCIPHERGUARD INDIA.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;